import utils from 'utils'

const xmlSchema = {
    440323: '<?xml version="1.0" encoding="GBK"?><FPXT><INPUT><QSRQ>{{applyDateStart}}</QSRQ><JZRQ>{{applyDateEnd}}</JZRQ><FPZL>{{invoiceType}}</FPZL><ZT>{{status}}</ZT></INPUT></FPXT> ',
    '0902': '<?xml version="1.0" encoding="GBK"?><FPFP><DATA><FJH>{{diskCode}}</FJH><FPZL>{{invType}}</FPZL><LBDM>{{typeCode}}</LBDM><QSHM>{{startNumber}}</QSHM><FPFS>{{invNumber}}</FPFS></DATA></FPFP>',
    // applyConfirm 发票申领确认
    440324: '<?xml version="1.0" encoding="GBK"?><FPXT><INPUT><SLXH>{{applySn}}</SLXH><FPZL>{{invoiceType1}}</FPZL> {{QRXX}}</INPUT></FPXT> ',
    '0903': '<?xml version="1.0" encoding="GBK"?><FPFP><DATA><FJH>{{diskCode}}</FJH><FPZL>{{invType}}</FPZL><FPSJ_Q>{{startDate}}</FPSJ_Q><FPSJ_Z>{{endDate}}</FPSJ_Z><FPZT>{{invStatus}}</ FPZT></DATA></FPFP>',
    '0902': '<?xml version="1.0" encoding="GBK"?><FPFP><DATA><FJH>{{diskCode}}</FJH><FPZL>{{invType}}</FPZL><LBDM>{{typeCode}}</LBDM><QSHM>{{startNumber}}</QSHM><FPFS>{{invNumber}}</FPFS></DATA></FPFP>',
    '0904': '<?xml version="1.0" encoding="GBK"?><FPFP><DATA><FPSJ_Q>{{startDate}}</FPSJ_Q><FPSJ_Z>{{endDate}}</FPSJ_Z></DATA></FPFP>',
    '0905': '<?xml version="1.0" encoding="GBK"?><FPFP><DATA><FPZL>{{invoiceType}}</FPZL><LBDM>{{invoiceTypeCode}}</LBDM><QSHM>{{invoiceNumberStart}}</QSHM><FPFS>{{invoiceCount}}</FPFS></DATA></FPFP>',
    '0906': '<?xml version="1.0" encoding="GBK"?><FPFP><DATA><FPZL>{{invType}}</FPZL><LBDM>{{typeCode}}</LBDM><QSHM>{{startNumber}}</QSHM><FPFS>{{invNumber}}</FPFS><FPJH>{{invNum}}</FPJH></DATA></FPFP>',
    '0901': '',
    '0907': '<?xml version="1.0" encoding="GBK"?><FPFP><DATA><QSRQ></QSRQ><ZZRQ></ZZRQ><FPZL></FPZL><FPZT>YTH</FPZT><KPJH></KPJH></DATA></FPFP>',
    '0908': '<?xml version="1.0" encoding="GBK"?><FPFP><DATA><FPZL>{{invType}}</FPZL><LBDM>{{typeCode}}</LBDM><QSHM>{{startNumber}}</QSHM><FPFS>{{invNumber}}</FPFS></DATA></FPFP>',
    440320: '',
    440321: '',
    // submitApplication 申领提交
    440322: '<?xml version="1.0" encoding="GBK"?><FPXT><INPUT><FPSL><FPZLXH>{{applyNum}}</FPZLXH><FPZL>{{invoiceType}}</FPZL><FPZLDM>{{invoiceTypeCode}}</FPZLDM><SLSL>{{applyCount}}</SLSL><MCFPXE>{{invoiceLimitCount}}</MCFPXE><ZJLX>{{certType}}</ZJLX><ZJHM>{{certNo}}</ZJHM><JBRXM>{{operatorName}}</JBRXM><SLFS>{{applyWay}}</SLFS><SLSM></SLSM><PSXX><SJRXX><SJR>{{consigneeName}}</SJR><YZBM>{{zipCode}}</YZBM><DZ>{{addressInfo}}</DZ><GH>{{phone}}</GH><YDDH>{{mobile}}</YDDH><BZ></BZ></SJRXX></PSXX></FPSL></INPUT></FPXT>',
    440325: '<?xml version="1.0" encoding="GBK"?><FPXT><INPUT><SLXH>{{applySn}}</SLXH><FPZL>{{invoiceType1}}</FPZL><FPZLDM>{{invoiceTypeCode}}</FPZLDM><SLSL>{{applyCount}}</SLSL></INPUT></FPXT> ',
    '0300': '<?xml version="1.0" encoding="GBK"?><FPFP><NO>{{applySn}}</NO><!--申领序号--><DATA><FPZL>{{invoiceType}}</FPZL><LBDM>{{invoiceTypeCode}}</LBDM><QSHM>{{invoiceNumberStart}}</QSHM><FPSL>{{applyCount}}</FPSL></DATA></FPFP>',
    '0302': '',
    // 切換發票聯式
    1101: '<?xml version="1.0" encoding="GBK"?><FPFP><DATA><FPZL>{{invType}}</FPZL><FPDM>{{invCode}}</FPDM><FPHM>{{startNumber}}</FPHM></DATA></FPFP>',
}

function replaceSpaces(source) {
    return source.replace(new RegExp(/(\r)/g), '')
        .replace(new RegExp(/(\n)/g), '')
}

function base64(input, codeType) {
    return $.ajax({
        type: 'POST',
        url: `${host.etcloudOvat}ovatInvoiceWait/base64DeCode`,
        contentType: 'application/json; charset=gbk',
        beforeSend(req) {
            const token = localStorage.getItem('id_token')
            if (token) {
                req.setRequestHeader('accessToken', token)
            }
        },
        data: JSON.stringify({
            invData: input,
            codeType,
            kpfs: 0,
        }),
    }).then((data) => {
        if (data.success) {
            return replaceSpaces(data.value)
        }
        return false
    })
}

function decode(input) {
    return base64(input, 'decode')
}

function encode(input) {
    return base64(input, 'encode')
}

function request(xml) {
    let realUrl = REAL_URL.replace('8888', localStorage.soapPort)
    return new Promise((resolve, reject) => {
        encode(JSON.stringify({
            param: xml
        })).then((SIDParam) => {
            SIDParam = SIDParam.replace(new RegExp('[+]', 'gm'), '%2B')
            const param = {
                SID: 20,
                SIDParam,
            }
            $.ajax({
                // url: 'http://127.0.0.1:8888/InvSvr',
                url: realUrl,
                type: 'post',
                data: param,
                // contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                timeout: 30000,
            }).then((data) => {
                const DECMSG = data.ENCMSG.replace(new RegExp('[_]', 'gm'), '+')
                    .replace(new RegExp(/(\r)/g), '')
                    .replace(new RegExp(/(\n)/g), '')
                decode(DECMSG).then((decoded) => {
                    const $xmlResponse = $($.parseXML(JSON.parse(decoded).responseMsg))
                    const resultCode = $xmlResponse.find('CODE')
                    if (resultCode.text() !== '0000') {
                        reject($xmlResponse.find('MESS').text())
                    } else {
                        decode($xmlResponse.find('DATA').text()).then((decodedData) => {
                            resolve(decodedData)
                        })
                    }
                })
            }, () => {
                reject('金税盘服务调用失败')
            })
        })
    })
}

function requesetXML(xml) {
    let realUrl = REAL_URL.replace('8888', localStorage.soapPort)
    return new Promise((resolve, reject) => {
        encode(JSON.stringify({
            param: xml
        })).then((SIDParam) => {
            SIDParam = SIDParam.replace(new RegExp('[+]', 'gm'), '%2B')
            const param = {
                SID: 20,
                SIDParam,
            }
            $.ajax({
                // url: 'http://127.0.0.1:8888/InvSvr',
                url: realUrl,
                type: 'post',
                data: param,
                // contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                timeout: 30000,
            }).then((data) => {
                const DECMSG = data.ENCMSG.replace(new RegExp('[_]', 'gm'), '+')
                    .replace(new RegExp(/(\r)/g), '')
                    .replace(new RegExp(/(\n)/g), '')
                // console.log(decode(DECMSG))
                decode(DECMSG).then((res) => {
                    const resObj = JSON.parse(res)
                    if (resObj.retcode == -1) {
                        reject(resObj.retmsg)
                    } else {
                        resolve(resObj.responseMsg)
                    }
                })
            }, () => {
                reject('金税盘服务调用失败')
            })
        })
    })
}

function makeSimpleXmlRequest(id, data, returnBase64) {
    const reg = /{{([a-zA-Z_$][a-zA-Z0-9_.]*)}}/g
    let xmlData = xmlSchema[id]
    xmlData = xmlData.replace(reg, (raw, key) => {
        if (data[key] || data[key] === 0) {
            return data[key]
        }
        return ''
    })
    console.log(xmlData, '-------请求前dataxml---------')
    return new Promise((resolve, reject) => {
        encode(replaceSpaces(xmlData)).then((encodedXmlData) => {
            const xmlWrapper = `<?xml version="1.0" encoding="GBK"?><FPXT_COM_INPUT><ID>${id}</ID><DATA>${encodedXmlData}</DATA></FPXT_COM_INPUT>`
            if (returnBase64) {
                resolve(requesetXML(xmlWrapper))
            } else {
                resolve(request(xmlWrapper))
            }
        }, (error) => {
            reject(error)
        })
    })
}

export default {
    /**
     * 获取金税盘信息返回税号，开票机号，开票服务器号
     * @return {[Promise]} [description]
     * 已知返回 {taxCode：'', machineNo: '', kpfwqh: '', CheckCode: ''}
     */
    getDiskInfo() {
        let realUrl = REAL_URL.replace('8888', localStorage.soapPort)
        return new Promise((resolve, reject) => {
            $.ajax({
                url: realUrl,
                data: {
                    SID: 25,
                    SIDParam: 'eyJTSURQYXJhbSI6ICI8P3htbCB2ZXJzaW9uPScxLjAnIGVuY29kaW5nPSdHQksnPz48RlBYVF9DT01fSU5QVVQ_PElEPjA0MDA8L0lEPjxEQVRBPjwvREFUQT48L0ZQWFRfQ09NX0lOUFVUPiJ9'
                },
                dataType: 'json',
                // responseType: 'arraybuffer',
                // contentType: 'application/json; charset=utf-8',
                timeout: 30000,
            }).then((data) => {
                const DECMSG = data.ENCMSG.replace(new RegExp('[_]', 'gm'), '+')
                    .replace(new RegExp(/(\r)/g), '')
                    .replace(new RegExp(/(\n)/g), '')
                resolve(decode(DECMSG))
            }, () => {
                reject('金税盘服务调用失败')
            })
        })
    },
    /**
     * [queryApplications description]
     * @param  {Object} param
     * {
     *     startDate,起始日期
     *     endDate,截至日期
     *     invType,发票种类 空：全部 0:增值税专用发票 2: 增值税普通发票 009:货物运输业增值税专用发票 005:机动车销售统一发票 025:增值税普通发票(卷票) 026:电子增值税普通发票
     *     status状态 空：全部 1：成功（该状态下的可确认） 2：失败 0：申领中 ，查询只需这几种状态，其它状态信息可查看返回的状态描述。
     *  }
     * @return {Promise}       [description]
     */
    queryApplications(param) {
        ({
            startDate: '',
            endDate: '',
            invType: '',
            status: '',
            ...param,
        })
        return makeSimpleXmlRequest(440323, param)
    },
    /**
     * [queryAssignedInvoice description]
     * @param  {Object} param
     * {
     *     diskCode,分机号
     *     startDate,起始日期
     *     endDate,截至日期
     *     invType,发票种类 空：全部 0:增值税专用发票 2: 增值税普通发票 009:货物运输业增值税专用发票 005:机动车销售统一发票 025:增值税普通发票(卷票) 026:电子增值税普通发票
     *     status状态 空：全部 1：成功（该状态下的可确认） 2：失败 0：申领中 ，查询只需这几种状态，其它状态信息可查看返回的状态描述。
     *  }
     * @return {Promise}       [description]
     */
    queryAssignedInvoice(param) {
        const params = {
            diskCode: '',
            startDate: '',
            endDate: '',
            invType: '',
            invStatus: '',
        }
        Object.assign(params, param)
        return makeSimpleXmlRequest('0903', params)
    },
    /**
     * [queryAssignedInvoiceBranch description]
     * @param  {Object} param
     * {
     *     startDate,起始日期
     *     endDate,截至日期
     *  }
     * @return {Promise}       [description]
     */
    queryAssignedInvoiceBranch(param) {
        const params = {
            startDate: '',
            endDate: '',
        }
        Object.assign(params, param)
        return makeSimpleXmlRequest('0904', params)
    },
    /**
     * [downloadInvoiceBranch description]
     * @param  {Object} param
     * {
     *     typeCode,类别代码
     *     startNumber,起始号码
     *     invNumber,份数
     *     invType,发票种类 空：全部 0:增值税专用发票 2: 增值税普通发票 009:货物运输业增值税专用发票 005:机动车销售统一发票 025:增值税普通发票(卷票) 026:电子增值税普通发票
     *  }
     * @return {Promise}       [description]
     */
    downloadInvoiceBranch(param) {
        const params = {
            typeCode: '',
            startNumber: '',
            invNumber: '',
            invType: '',
        }
        Object.assign(params, param)
        return makeSimpleXmlRequest('0905', params)
    },
    /**
     * [retreatInvoiceBranch description]
     * @param  {Object} param
     * {
     *     typeCode,类别代码
     *     startNumber,起始号码
     *     invNumber,份数
     *     invType,发票种类 空：全部 0:增值税专用发票 2: 增值税普通发票 009:货物运输业增值税专用发票 005:机动车销售统一发票 025:增值税普通发票(卷票) 026:电子增值税普通发票
     *     invNum,发票券号
     * }
     * @return {Promise}       [description]
     */
    retreatInvoiceBranch(param) {
        const params = {
            invType: '',
            typeCode: '',
            startNumber: '',
            invNumber: '',
            invNum: '',
        }
        Object.assign(params, param)
        return makeSimpleXmlRequest('0906', params)
    },
    /**
     * [queryInvoiceStock description]
     * @return {Promise}       [description]
     */
    queryInvoiceStock() {
        return makeSimpleXmlRequest('0901', {})
    },
    /**
     * 获取权限和征管类型
     */
    queryZglx() {
        return makeSimpleXmlRequest(440320)
    },
    /**
     *
     * 主盘向分机分配发票
     * diskCode 分机号
     * invType  发票种类
     * typeCode 类别代码
     * startNumber 起始号码
     * invNubmer   发票份数
     */
    queryDistribution(param) {
        const params = {
            diskCode: '',
            invType: '',
            typeCode: '',
            startNumber: '',
            invNumber: '',
        }
        Object.assign(params, param)
        return makeSimpleXmlRequest('0902', params)
    },
    /**
     */
    queryRetrieve() {
        return makeSimpleXmlRequest('0907', {}, 1)
    },
    /**
     * 主盘收回发票
     ** invType  发票种类
     * typeCode 类别代码
     * startNumber 起始号码
     * invNubmer   发票份数
     *
     * @param {*} param
     * @returns
     */
    mainRetrieve(param) {
        const params = {
            invType: '',
            typeCode: '',
            startNumber: '',
            invNumber: '',
        }
        Object.assign(params, param)
        return makeSimpleXmlRequest('0908', params)
    },
    /* 获取授权
    * @return<FPZLMC></FPZLMC> --发票种类名称
   < FPZLDM ></FPZLDM > --发票种类代码
       < MCFPXE ></MCFPXE > --每次发票限额
           < FPZL ></FPZL > --发票种类
     */
    getApplyAuth() {
        return makeSimpleXmlRequest(440321)
    },
    /**
     * 申领提交
     */
    submitApplication(param) {
        return makeSimpleXmlRequest(440322, param)
    },
    /**
     * 发票申领确认
     * @param  {[type]} param [description]
     * @return {[type]}       [description]
     */
    applyConfirm(param) {
        return makeSimpleXmlRequest(440324, param)
    },
    /**
     * 读入到主盘
     * @return {[type]} [description]
     */
    readToMainDisk(param) {
        return makeSimpleXmlRequest('0300', param)
    },
    /**
     * 撤销申购
     * @return {[type]} [description]
     */
    revertApplication(param) {
        return makeSimpleXmlRequest(440325, param)
    },
    /**
     * 查询可下载票源
     * @return {[type]} [description]
     */
    queryReadStatus() {
        return makeSimpleXmlRequest('0302')
    },
    /**
     *切換聯式發票
     * @param  {Object} param
     * {
     *     invType,发票种类
     *     invCode,发票代码
     *     startNumber，起始号码
     *  }
     * @return {Promise}       [description]
     */
    changeInvoiceUnionType(param) {
        const params = {
            invType: '',
            invCode: '',
            startNumber: '',
        }
        Object.assign(params, param)
        return makeSimpleXmlRequest('1101', params)
    },
}


// WEBPACK FOOTER //
// ./src/common/services/stockService.js